import React, { useState, useEffect } from "react";
import axiosInstance from "../../../utils/axiosInstance";
import DataTableComponent from "../../tools/DataTableComponent";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import { useFormik } from "formik";
import * as Yup from "yup";

const validationsSchema = Yup.object({
    nameLat: Yup.string()
        .required("Le nom du pays est obligatoire")
        .max(150, "150 caractères max"),
});

function Countries() {
    const [countries, setCountries] = useState([]);
    const [form, setForm] = useState({
        id: 0,
        nameAr: "",
        nameLat: ""
    });
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [loading, setLoading] = useState(true);
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const token = localStorage.getItem("token");
    const columnsMapping = {
        nameLat: "Nom   "
    };
    // sans tableau de dépendances, ou dont le tableau contient l’état qu’il met lui-même à jour. Le composant charge les pays, met l’état à jour, se ré-affiche, relance le chargement, et ainsi de suite sans fin
    useEffect(() => {
        fetchCountries(); // Charger les pays
    }, []);

    const fetchCountries = () => {
        axiosInstance.get(`${baseUrl}/api/Countries/getCountries`)
            .then(response => {
                setCountries(response.data);
            })
            .catch(() => console.log("Impossible de charger."))
            .finally(() => setLoading(false));
    };

    const formik = useFormik({
        initialValues: {
            id: 0,
            nameLat: ""
        },
        validationSchema: validationsSchema,
        onSubmit: async (values, { setErrors, resetForm }) => {
            const url = values.id
                ? `${baseUrl}/api/Countries/UpdateCountry`
                : `${baseUrl}/api/Countries/CreateCountry`;

            try {
                await axiosInstance.post(url, values);

                window.$("#modalForm").modal("hide");
                Swal.fire({
                    toast: true,
                    position: "top-end",
                    icon: "success",
                    title: "Opération réussie",
                    showConfirmButton: false,
                    timer: 2000
                });

                fetchCountries();
                resetForm();
                setSelectedCountry(null);
            } catch (error) {
                // 🔴 erreurs serveur (ModelState)
                if (error.response?.data?.errors) {
                    setErrors(error.response.data.errors);
                } else {
                    Swal.fire({
                        toast: true,
                        position: "top-end",
                        icon: "error",
                        title: "Échec de l'opération",
                        showConfirmButton: false,
                        timer: 2000
                    });
                }
            }
        }
    });
    const resetForm = () => {
        formik.resetForm();
        setSelectedCountry(null);
    };
    const handleEdit = (country) => {
        setSelectedCountry(country);
        formik.setValues(country);
        setTimeout(() => window.$("#modalForm").modal("show"), 100);
    };

    const handleDelete = (id) => {
        Swal.fire({
            title: "Êtes-vous sûr ?",
            text: "Cette action est irréversible !",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Oui, supprimer",
            cancelButtonText: "Annuler"
        }).then((result) => {
            if (result.isConfirmed) {
                axiosInstance.post(`${baseUrl}/api/Countries/DeleteCountry`,
                    { 'id': id, 'idString': '' })
                    .then(() => {
                        Swal.fire("Supprimé", "Le pays a été supprimé", "success");
                        setCountries((prev) => prev.filter((item) => item.id !== id));
                    })
                    .catch(() => console.log("Echec de l'opération."));
            }
        });
    };

    return (
        <div className="container-fluid mt-4">
            <h3 className="text-center my-3">Gestion des Pays</h3>
            <button className="btn btn-primary btn-ajouter mb-3" data-toggle="modal" data-target="#modalForm" ><i className="fas fa-plus"></i>Ajouter</button>


            {loading ? (
                <p>Chargement...</p>
            ) : (
                <DataTableComponent
                    title="Liste des pays"
                    columns={["nameLat"]}
                    columnsMapping={columnsMapping}
                    keyField="id"
                    data={countries}
                    handleEdit={handleEdit}
                    handleDelete={handleDelete}
                />
            )}

            <div className="modal fade" id="modalForm" tabIndex="-1" role="dialog">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{selectedCountry ? "Modifier" : "Ajouter"} un pays</h5>
                            <button type="button" className="close" data-dismiss="modal" onClick={resetForm}>
                                <span>&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="form-group">
                                <label>Nom du pays</label>
                                <input
                                    type="text"
                                    name="nameLat"
                                    className={`form-control ${formik.touched.nameLat && formik.errors.nameLat
                                        ? "is-invalid"
                                        : ""
                                        }`}
                                    value={formik.values.nameLat}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                                {formik.touched.nameLat && formik.errors.nameLat && (
                                    <div className="invalid-feedback">
                                        {formik.errors.nameLat}
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={resetForm} >Annuler</button>
                            <button type="button" className="btn btn-primary" onClick={formik.handleSubmit}>Sauvegarder</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Countries;
